import React, { useState } from 'react';
import Box from '@mui/material/Box';
import Divder from '../../Components/CommonComp/Divder';
import CustomBox from '../../Components/CommonComp/CustomBox/CustomBox';
import { JObWorkDataList } from '../../data/jobworkData';
import CustomTabs from '../../Components/CommonComp/CustomTabs/CustomTabs';
import ChalanTabBody from '../../Components/Chalan/DesignListTabBody';
import JobworkTabBody from '../../Components/Jobwork/JobworkTabBody';

function Jobwork({ handleNavParams, addUserModal, handleAddUserModal }) {
  const [tabValue, setTabValue] = useState(1);

  const handleTabs = (data) => {
    setTabValue(data.id);
    handleNavParams({
      navTitle: data.label,
    });
  };

  return (
    <Box
      component="main"
      sx={(theme) => {
        return {
          flexGrow: 1,
          // bgcolor: theme.backgroundColor.box.main,
          // p: 4,
          // pl: 0,
          // pl: 0,
        };
      }}
    >
      <CustomBox padding={0}>
        <CustomTabs tabList={JObWorkDataList.tabs} tabClick={handleTabs} />
      </CustomBox>
      <Divder spacing={1} />
      <JobworkTabBody activeTab={tabValue} />
      <Divder spacing={1.2} />
    </Box>
  );
}

export default Jobwork;
